import Swal from 'sweetalert2';
import Images from './../../../config/Images'
import translateLabel from "../../shared/translation";

export const NoRecFoundAlert = () => {
    if (!localStorage.getItem("SessionExpired") || localStorage.getItem("SessionExpired") === "false") {
        return Swal.fire({
            text: translateLabel('NO_RECORDS_FOUND'),
            imageUrl: Images.NoApplication,
            imageWidth: 200,
            imageHeight: 150,
            imageAlt: Images.NoApplication,
            confirmButtonColor: '#056ca2',
            confirmButtonText: translateLabel('OK')
        });
    }
}

export const SuccessAlert = (textMessage) => {
    return Swal.fire({
        title: translateLabel('SUCCESS'),
        text: textMessage ? translateLabel(textMessage) : "",
        icon: 'success',
        confirmButtonColor: '#056ca2',
        confirmButtonText: translateLabel('OK')
    });
}

export const WarningAlert = (textMessage, titleMessage) => {
    if (!localStorage.getItem("SessionExpired") || localStorage.getItem("SessionExpired") === "false") {
        return Swal.fire({
            title: titleMessage ? translateLabel(titleMessage) : translateLabel("Warning"),
            text: textMessage ? translateLabel(textMessage) : "",
            imageUrl: Images.WarningAlertImg,
            imageWidth: 200,
            imageHeight: 100,
            imageAlt: Images.WarningAlertImg,
            // confirmButtonColor: '#056ca2',
            confirmButtonText: translateLabel('OK')
        })
    }
}

